import isLocationUniteKingdom from './isLocationUnitedKingdom'
const locationListIncludesUnitedKingdom = (locations: string[]): boolean =>
  locations.some((location) => isLocationUniteKingdom(location))

export default locationListIncludesUnitedKingdom
